import { usePopper } from 'react-popper';

/** This hook is a tooltip and popover positioning engine.
 * and is based on react popper (https://popper.js.org/react-popper/)
*/
const usePositionPopup = (referenceElement, popperElement, options) => {
  const popperOptions = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || []
  };
  const { state, styles, attributes, update, forceUpdate } = usePopper(
    referenceElement,
    popperElement,
    popperOptions
  );

  return {
    state,
    styles,
    attributes,
    update,
    forceUpdate
  };
};

export default usePositionPopup;